import Flex from "../../components/Flex";
import { NonNullableDate } from "../../utils/date-time-utility";
import PsychoeducationSection from "../_shared/PsychoeducationSection";
import { PsychodynamicBlock } from "../_shared/TherapyBlocks";
import AllergiesBlock from "../_shared/AllergiesBlock";
import HistoryBlock from "../_shared/HistoryBlock";
import MedicationsBlock from "../_shared/MedicationsBlock";
import VitalsBlock from "../_shared/VitalsBlock";
import RosBlock from "../_shared/RosBlock";
import PhysicalExamBlock from "../_shared/PhysicalExamBlock";
import ScreeningAssessmentBlock from "../_shared/ScreeningAssessmentBlock";
import AssessmentBlock from "../_shared/AssessmentBlock";
import PrescriptionsBlock from "../_shared/PrescriptionsBlock";
import VaccinesBlock from "../_shared/VaccinesBlock";
import CptCodesBlock from "../_shared/CptCodesBlock";
import {
  CarePlanTemplateList,
  KeyValPair,
  OrderList,
  RenderTextWithContainerPattern,
  ReportSection,
} from "../constant";

interface PsychodynamicTherapyNoteTemplateProps {
  data: any;
}

const PsychodynamicTherapyNoteTemplate = ({
  data,
}: PsychodynamicTherapyNoteTemplateProps) => {
  const hasSessionInfo = data?.sessionDate || data?.duration;

  return (
    <>
      {/* ── Subjective ── */}
      <ReportSection label="Subjective">
        <RenderTextWithContainerPattern
          label="History of Present Illness"
          val={data?.historyOfPresentIllness}
        />
        <RenderTextWithContainerPattern
          label="Subjective"
          val={data?.subjectiveFreeNote}
        />
        <AllergiesBlock data={data} />
        <HistoryBlock data={data} />
        <RenderTextWithContainerPattern label="Habits" val={data?.habits} />
        <MedicationsBlock data={data} />
      </ReportSection>

      {/* ── Objective ── */}
      <ReportSection label="Objective">
        <RenderTextWithContainerPattern
          label="Objective"
          val={data?.objectiveFreeNote}
        />
        <VitalsBlock data={data} />
        <PhysicalExamBlock data={data} />
        <RosBlock data={data} />
        <ScreeningAssessmentBlock data={data} />
      </ReportSection>

      {/* ── Assessment ── */}
      <ReportSection label="Assessment">
        <AssessmentBlock data={data} />
      </ReportSection>

      {/* ── Plan ── */}
      <ReportSection label="Plan">
        <RenderTextWithContainerPattern label="Plan" val={data?.planFreeNote} />
        <PrescriptionsBlock data={data} />
        <VaccinesBlock data={data} />
        <OrderList orders={data?.patientOrders} />
        <CptCodesBlock data={data} />
        <RenderTextWithContainerPattern
          label="Care Plan"
          val={data?.carePlan}
        />
        <CarePlanTemplateList carePlanTemplates={data?.carePlanTemplates} />
        <RenderTextWithContainerPattern
          label="Instructions"
          val={data?.instruction}
        />
      </ReportSection>

      {/* ── Psychodynamic Therapy Specific ── */}
      <ReportSection label="Psychodynamic Therapy">
        <Flex flexDirection={"column"} gap={1} mt={1} p={1}>
          {hasSessionInfo && (
            <>
              {data?.sessionDate && (
                <KeyValPair
                  k="Session Date"
                  v={NonNullableDate(data.sessionDate) ?? "-"}
                />
              )}
              {data?.duration && (
                <KeyValPair k="Duration" v={`${data.duration} minutes`} />
              )}
            </>
          )}

          <PsychodynamicBlock data={data} primaryModalityLabel="Appearance" />
        </Flex>
      </ReportSection>

      {/* ── Follow-Up ── */}
      <ReportSection label="Follow-Up">
        <RenderTextWithContainerPattern
          label="Follow Up"
          val={data?.followUp}
        />

        {/* ── Psychoeducation Session (shown below Follow Up only when required) ── */}
        <PsychoeducationSection data={data} />
      </ReportSection>
    </>
  );
};

export default PsychodynamicTherapyNoteTemplate;
